<template lang="pug">
  b-modal#addPage(
  ref="addPage"
  :title="$t('ui.combine.add_page')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.id')").mb-0
        DebounceInput(
          size="sm"
          ref="dataAdd_pageId"
          required
          alphaNum
          type="text"
          :dirty="$v.dataAdd_pageId.$dirty"
          :error="$v.dataAdd_pageId.$error"
          v-model.trim.lazy="$v.dataAdd_pageId.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_pageId.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataAdd_pageId" :name="$t('ui.id')")
      b-form-group(:label="$t('ui.name')").mb-0
        DebounceInput(
          size="sm"
          required
          type="text"
          :dirty="$v.dataAdd_pageName.$dirty"
          :error="$v.dataAdd_pageName.$error"
          v-model.trim.lazy="$v.dataAdd_pageName.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_pageName.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataAdd_pageName" :name="$t('ui.name')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      dataAdd_pageId: "",
      dataAdd_pageName: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    dataAdd_pageId: {
      required,
      alphaNum,
      minLength: minLength(2),
      maxLength: maxLength(20)
    },
    dataAdd_pageName: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(50)
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.addPageUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.page,
          new_page_id: this.dataAdd_pageId,
          new_page_name: this.dataAdd_pageName
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = (typeof response.data.status == "string") ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked", this.dataAdd_pageId, this.dataAdd_pageName);
                  this.$refs.addPage.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  // this.$emit("failed", "add_page", this.feedback.status);
                  // this.$refs.addPage.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.dataAdd_pageId = "";
      this.dataAdd_pageName = "";
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.dataAdd_pageId.$el.focus();
    }
  }
};
</script>
